import { render, staticRenderFns } from "./AccountComp.vue?vue&type=template&id=8aebcb50&scoped=true&"
import script from "./AccountComp.vue?vue&type=script&lang=js&"
export * from "./AccountComp.vue?vue&type=script&lang=js&"
import style0 from "./AccountComp.vue?vue&type=style&index=0&id=8aebcb50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aebcb50",
  null
  
)

export default component.exports